import { Row } from "../../../components/row";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/table";
import type { EventCategoryModel, EventDetailModel } from "../types/LiveEvent";

type EventDetailTableProps = {
    data: EventDetailModel[] | null;
    maxHeight?: string;
    maxWidth?: string;
    scale?: number;
};

const renderStatusBag = (status: string) => {
    if (status == "Completed") {
        return (
            <span className={`py-1 px-2 whitespace-nowrap border rounded-sm font-semibold text-[#364153] bg-[#F3F4F6] border-[#F3F4F6]`}>
                {status}
            </span>)
    }
    else if (status == "Starting Soon") {
        return (
            <span className={`py-1 px-2 whitespace-nowrap border rounded-sm font-semibold text-[#1447E6] bg-[#DBEAFE] border-[#DBEAFE]`}>
                {status}
            </span>)
    }
    else if (status == "Ending Soon") {
        return (
            <span className={`py-1 px-2 whitespace-nowrap border rounded-sm font-semibold text-[#CA3500] bg-[#FFEDD4] border-[#FFEDD4]`}>
                {status}
            </span>)
    }
    else {
        return (
            <span className={`py-1 px-2 whitespace-nowrap border rounded-sm font-semibold text-[#008236] bg-[#DCFCE7] border-[#DCFCE7]`}>
                {status}
            </span>
        )
    }
}

const renderCategoryNames = (categories: EventCategoryModel[]) => {
    return categories.map(cat => cat.name).join(", ");
}

const renderEventTime = (start: Date) => {
    const startDate = new Date(start);

    const dateStr = startDate.toLocaleDateString("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).replace(/\//g, ".");
    const timeStr = startDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return (
        <div>
            <span className="block">{dateStr}</span>
            <span className="block text-[#6A7282]">{timeStr}</span>
        </div>
    )
}

export default function EventDetailTable({ data: eventDetails, maxHeight = "400px", maxWidth = "100%", scale = 1 }: EventDetailTableProps) {
    return (
        <div style={{ maxWidth }} className="mt-5 w-full border border-gray-200 dark:border-gray-700 rounded-lg">
            <div className="min-h-[10px]"></div>
            <span className="px-6 py-6">Event Details ({eventDetails?.length || 0})</span>
            <Row style={{ transform: `scale(${scale})`, transformOrigin: "top left" }} className="mt-5">
                <Table style={{ maxHeight }}>
                    <TableHeader className="bg-[#F7F8FA] dark:bg-gray-700 sticky top-[-5px] z-10">
                        <TableRow>
                            <TableHead className="max-w-[160px] pr-2 text-[#364153] dark:text-gray-100 font-bold">Event Name</TableHead>
                            <TableHead className="px-2 text-center text-[#364153] dark:text-gray-100 font-bold">Status</TableHead>
                            <TableHead className="px-2 text-center text-[#364153] dark:text-gray-100 font-bold">Date</TableHead>
                            <TableHead className="px-2 text-center text-[#364153] dark:text-gray-100 font-bold">Total</TableHead>
                            <TableHead className="px-2 text-center text-[#364153] dark:text-gray-100 font-bold">CivicPoints</TableHead>
                            <TableHead className="px-2 text-center text-[#364153] dark:text-gray-100 font-bold">Non-Users</TableHead>
                            <TableHead className="pl-2 text-center text-[#364153] dark:text-gray-100 font-bold">Engagement</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {eventDetails?.map((data: EventDetailModel) => {
                            return (
                                <TableRow key={data?.event_id}>
                                    <TableCell className="pr-2 max-w-[160px]">
                                        <span className="block w-full font-bold">{data?.event_name}</span>
                                        <span className="block w-full text-[#6A7282] text-sm">{renderCategoryNames(data?.categories)}</span>
                                    </TableCell>
                                    <TableCell className="px-2 text-center">
                                        {renderStatusBag(data?.status)}
                                    </TableCell>
                                    <TableCell className="px-2 text-center">
                                        {renderEventTime(data?.start_time)}
                                    </TableCell>
                                    <TableCell className="px-2 text-center">
                                        {data?.total_attendees}
                                    </TableCell>
                                    <TableCell className="px-2 text-center text-[#00A63E] font-semibold">
                                        {data?.civic_points_users}
                                    </TableCell>
                                    <TableCell className="px-2 text-center text-[#F54900] font-semibold">
                                        0
                                    </TableCell>
                                    <TableCell className="pl-2 text-center font-semibold">
                                        {data?.engagement_rate?.toFixed(2) || 0}%
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Row>
        </div>
    )
}
